import { IReduxAction } from '../../../reducers'
import { DataPromise, shouldDispatchLoad } from '../../../context/AxiosContext'
import BaseDropdown, { ComboBoxOption, DropdownProps } from '../../../components/Dropdown/BaseDropdown'
import * as React from 'react'
import { PropsWithChildren, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMount } from '@fluentui/react-hooks'

type Props<D> = DropdownConnectProps<D> & {
    items: DataPromise<D[]>
    load: () => IReduxAction
    reset: () => IReduxAction
    mapper: (items: D[]) => ComboBoxOption<D>[]
}

export type DropdownConnectProps<D> = Omit<DropdownProps<D>, 'options'>

export default function DropdownConnect<D>(props: PropsWithChildren<Props<D>>) {
    const dispatch = useDispatch()
    const [options, setOptions] = useState<ComboBoxOption[]>()

    useMount(() => {
        if (props.items.rejected) {
            dispatch(props.reset())
        }
    })

    useEffect(() => {
        if (shouldDispatchLoad(props.items)) {
            dispatch(props.load())
        }
    }, [props.items.loading])

    useEffect(() => {
        if (props.items.loaded) {
            setOptions(props.mapper(props.items.data))
        }
    }, [props.items.data, props.mapper])

    return <BaseDropdown<D> {...props} options={options} />
}
